import { isMixed, lastEffectiveValue, mixin } from './mix';
import { Hub, State } from './Hub';
import { DefaultRules } from './rules';
import { isIterable } from './value';
import { ItemOp, reconcile } from './reconcile';
export const defaultGearFactory = (opts, context, scope, rules) => {
    return new Gear(opts, context, scope);
};
export const defaultInitRules = {
    defaultItem: DefaultRules.Option,
    defaultComponent: DefaultRules.Option,
    components: DefaultRules.OptionCollection,
    templates: DefaultRules.OptionCollection,
};
export const defaultPatchRules = {
    defaultItem: DefaultRules.OptionCollectionOverlap,
    defaultComponent: DefaultRules.OptionCollectionOverlap,
    components: DefaultRules.OptionCollectionOverlap,
    templates: DefaultRules.OptionCollectionOverlap,
    items: DefaultRules.Overlap,
};
export function defaultGearSort(a, b) {
    const w1 = (a.options && a.options.weight) || 0;
    const w2 = (b.options && b.options.weight) || 0;
    if (w1 == w2) {
        const i1 = a.index || 0;
        const i2 = b.index || 0;
        return i1 - i2;
    }
    return w1 - w2;
}
export const isGear = (obj) => {
    return obj != null && obj.addIndexed != null;
};
var Command;
(function (Command) {
    Command["Add"] = "add";
    Command["Remove"] = "remove";
})(Command || (Command = {}));
// const command = (cmd: Command, idx?: number, key?: string) => {
//     console.log(cmd, idx, key)
// }
export class Gear extends Hub {
    constructor(options, context, scope) {
        super(options, context, scope);
        this.components = {};
        this.items = [];
        this.commands = [];
    }
    patch(optPatch) {
        super.patch(optPatch);
        // if (this.state == State.Destroying || this.state == State.Destroyed) {
        //     return
        // }
        const o = this.options;
        // console.log(optPatch)
        // console.log(o)
        if (optPatch.templates != null) {
            // FIXME в options.components должен находится только {key: Options}
            const components = o.components;
            if (components && components !== true) {
                // пересоздаем компоненты
                for (let k in optPatch.templates) {
                    // if (this.components[k]) {
                    //     this.updateComponent(k, o.components[k] as B)
                    // }
                    // console.log('template component', k, components[k])
                    if (components[k] === undefined) {
                        this.addKeyed(k, null);
                    }
                }
            }
            else if (components == null) {
                // создаем компоненты по умолчанию
                for (let k in optPatch.templates) {
                    this.addKeyed(k, null);
                }
            }
        }
        if (optPatch.components != null) {
            const components = o.components;
            if (components === true) {
                for (let k in o.templates) {
                    this.addKeyed(k, null);
                }
            }
            else if (components === false) {
                // TODO здесь мы должны выключать все компоненты
            }
            else {
                if (isIterable(components)) {
                    this.syncKeyed(components);
                }
                else {
                    // FIXME optPatch.components может быть boolean
                    const patchedComponents = {};
                    for (let k in optPatch.components) {
                        //                        if (components[k] !== undefined) {
                        patchedComponents[k] = components[k];
                        //                        }
                    }
                    this.syncKeyed(patchedComponents);
                }
            }
        }
        if (optPatch.items) {
            if (o.items === true) {
            }
            else if (o.items === false) {
            }
            else {
                this.syncIndexed(o.items);
            }
        }
    }
    initRules() {
        return defaultInitRules;
    }
    patchRules() {
        return defaultPatchRules;
    }
    //-----------------------
    // Keyed
    //-----------------------
    addKeyed(key, blueprint, scope) {
        var _a, _b;
        if (this.components[key]) {
            console.error('Component already exists', key);
        }
        // if (blueprint == null) {
        //     return
        // }
        if (isMixed(blueprint)) {
            console.error('Component should not be of mixed type');
            const last = lastEffectiveValue(blueprint);
            if (last === false || last == null) {
                return;
            }
        }
        else if (isGear(blueprint)) {
            // FIXME
            // if (blueprint.parent) {
            //     // FIXME это надо заменить на removeChild
            //     blueprint.key ? blueprint.parent.removeKeyed(blueprint.key) : blueprint.parent.removeIndexed(blueprint.index)
            // }
            blueprint.parent = this;
            blueprint.key = key;
            this.components[key] = blueprint;
            return blueprint;
        }
        else if (blueprint instanceof Promise) {
            blueprint.then(asyncBlueprint => {
                this.addKeyed(key, asyncBlueprint, scope);
            });
            return;
        }
        const { defaultComponent, templates, componentFactory } = this.options;
        const template = templates ? templates[key] : undefined;
        //        const templates = this.parent.options.templates
        const compOpts = mixin(defaultComponent, template, blueprint).build(this.initRules());
        if (compOpts) {
            //            console.log('addKeyed', key, compOpts)
            //            console.log(scope)
            const comp = (componentFactory || this.scope.$defaultFactory)(compOpts, this.scope, scope);
            comp.key = key;
            comp.parent = this;
            this.components[key] = comp;
            (_b = (_a = this.events).afterAddKeyed) === null || _b === void 0 ? void 0 : _b.call(_a, comp, this.scope);
            this.commands.push([Command.Add, undefined, key]);
            //            command(Command.Add, undefined, key)
            return comp;
        }
    }
    removeKeyed(key) {
        var _a, _b;
        (_b = (_a = this.events).beforeRemoveKeyed) === null || _b === void 0 ? void 0 : _b.call(_a, key, this.scope);
        delete this.components[key];
        //        command(Command.Remove, undefined, key)
        this.commands.push([Command.Remove, undefined, key]);
    }
    updateKeyed(key, blueprint) {
        this.components[key].destroy();
        this.addKeyed(key, blueprint);
    }
    syncKeyed(next) {
        //        console.log('sync-keyed', this.key, next)
        var _a, _b;
        if (isIterable(next)) {
            const it = next;
            const key = it.$name;
            const components = Object.assign({}, this.components);
            const componentsToUpdate = {};
            const componentsToAdd = {};
            next.$each(result => {
                const k = result.$uid;
                if (k in components) {
                    componentsToUpdate[k] = components[k];
                    // console.log(components[k].key, components[k].uid, k)
                    // if (components[k].uid != k) {
                    //     debugger
                    // }
                }
                else {
                    componentsToAdd[k] = result;
                }
                delete components[k];
            });
            //            console.log(next)
            for (let k in componentsToAdd) {
                // FIXME не бьются типы скоупа и нового элемента
                const comp = this.addKeyed(k, {}, { [key]: componentsToAdd[k] });
                comp.uid = k;
            }
            for (let k in components) {
                this.removeKeyed(k);
            }
            for (let k in componentsToUpdate) {
                console.warn('Component update not yet ready');
                // TODO
            }
        }
        else {
            // свойство аддитивности позволяет обновлять элементы поотдельности
            for (let k in next) {
                const nextComp = next[k].build(this.initRules());
                //                console.log('Next comp', k, nextComp, next[k])
                const comp = this.components[k];
                if (nextComp === false) {
                    if (comp) {
                        if (comp.parent == this) {
                            // для собственных компонентов начинаем процедуру удаления
                            comp.destroy();
                        }
                        else {
                            // компонент-кукушку просто убираем из списка
                            this.removeKeyed(k);
                        }
                    }
                }
                else if (nextComp === true) {
                    if (!comp) {
                        this.addKeyed(k, {});
                    }
                    else if (comp.state == State.Destroying) {
                        console.log('stop destroying', k);
                        comp.reinit();
                    }
                    else {
                        if (comp.state == State.Destroyed) {
                            console.warn('component already destroyed', k);
                        }
                    }
                }
                else if (nextComp != null) {
                    if (!comp) {
                        this.addKeyed(k, nextComp);
                    }
                    else {
                        // FIXME здесь мы предполагаем, что в next именно options
                        comp.reinit(nextComp);
                    }
                }
                else {
                    // игнорируем пустые компоненты
                }
            }
        }
        (_b = (_a = this.events).afterSyncKeyed) === null || _b === void 0 ? void 0 : _b.call(_a, this.components, this.scope);
    }
    //-----------------------
    // Indexed
    //-----------------------
    addIndexed(blueprint, idx, scope) {
        if (blueprint == null) {
            return;
        }
        if (isMixed(blueprint)) {
            //            console.error('Item should not be of mixed type')
            const last = lastEffectiveValue(blueprint);
            if (last === false || last == null) {
                return;
            }
        }
        else if (isGear(blueprint)) {
            // FIXME
            this.items.push(blueprint);
            return blueprint;
        }
        else if (blueprint instanceof Promise) {
            blueprint.then(asyncBlueprint => {
                this.addIndexed(asyncBlueprint, idx, scope);
            });
            return;
        }
        const { defaultItem, itemFactory } = this.options;
        //const template = templates ? templates[templateKey] : undefined
        const itemOpts = mixin(defaultItem /*, template*/, blueprint).build(this.initRules());
        //        console.log(itemOpts)
        if (itemOpts) {
            let index = idx;
            if (index == null) {
                index = this.items.length;
            }
            else {
                for (let i = index; i < this.items.length; i++) {
                    this.items[i].index++;
                }
            }
            const item = (itemFactory || this.scope.$defaultFactory)(itemOpts, this.scope, scope);
            item.index = index;
            item.parent = this;
            this.items.splice(index, 0, item);
            //            command(Command.Add, index, undefined)
            this.commands.push([Command.Add, index, undefined]);
            return item;
        }
    }
    updateIndexed(idx, blueprint) {
        // TODO
    }
    removeIndexed(idx) {
        this.items.splice(idx, 1);
        this.items.forEach(itm => {
            if (itm.index > idx) {
                itm.index--;
            }
        });
        //        command(Command.Add, idx, undefined)
        this.commands.push([Command.Remove, idx, undefined]);
    }
    syncIndexed(next) {
        //        console.log('sync indexed', this.key, next)
        var _a, _b;
        if (isIterable(next)) {
            const it = next;
            const key = it.$name;
            //            console.log('iterable', key, it)
            const prevItems = [];
            this.items.forEach(item => {
                prevItems.push({
                    key: String(item.uid),
                    value: item
                });
            });
            const nextItems = [];
            next.$each((result, key) => {
                nextItems.push({
                    key: result.$uid === undefined ? key : result.$uid,
                    value: result
                });
            });
            // let result = it.next()
            // while (!result.done) {
            //     nextItems.push({
            //         key: result.value.$uid,
            //         value: result.value
            //     })
            //     result = it.next()
            // }
            //            console.log('next items', nextItems, prevItems)
            //            console.log('reconcile')
            const mergedItems = reconcile(prevItems, nextItems);
            //            console.log('reconcile end')
            //            console.log('merged items', this.key, mergedItems)
            const children = [];
            let i = 0;
            mergedItems.forEach((itm) => {
                let item = null;
                if (itm.op == ItemOp.ADD) {
                    const v = itm.value;
                    item = this.addIndexed({}, i, key != null ? { [key]: v } : v);
                    item.uid = itm.key; // v.$uid
                    //                        console.log('add', i, itm.key)//v.$uid)
                }
                else if (itm.op == ItemOp.DELETE) {
                    item = itm.value;
                    item.parent = null;
                    item.destroy();
                    item.parent = this;
                    if (item.state == State.Destroyed) {
                        i--;
                        item = null;
                    }
                    // else {
                    //     debugger
                    // }
                    //                        console.log('del', i, itm.key)
                }
                else {
                    item = itm.value;
                    item.index = i;
                    //                        console.log('upd', i, itm.key, itm.value)
                }
                item && children.push(item);
                i++;
            });
            this.items = children;
            //            console.log(this.items)
        }
        else {
            //            console.log(next)
            if (!Array.isArray(next)) {
                console.error('Items must be array like value', next);
            }
            // у индексированных элементов нет свойства аддитивности, поэтому пересоздаем все элементы
            this.items.forEach(item => {
                delete item.parent;
                item.destroy();
            });
            this.items = [];
            for (let o of next) {
                this.addIndexed(o);
            }
        }
        (_b = (_a = this.events).afterSyncIndexed) === null || _b === void 0 ? void 0 : _b.call(_a, this.items, this.scope);
    }
    destroy(deferred) {
        super.destroy(() => {
            deferred && deferred();
            if (this.parent) {
                if (this.key) {
                    this.parent.removeKeyed(this.key);
                }
                else {
                    this.parent.removeIndexed(this.index);
                }
            }
            for (let child of this.items) {
                delete child.parent;
                child.destroy();
            }
            for (let k in this.components) {
                const child = this.components[k];
                delete child.parent;
                child.destroy();
            }
            delete this.parent;
            delete this.key;
            delete this.index;
            this.items = [];
            this.components = {};
        });
    }
    get children() {
        let children = [].concat(this.items).concat(Object.values(this.components)).filter(c => c.parent == this);
        if (this.options.childFilter) {
            children = children.filter(this.options.childFilter);
        }
        return children.sort(this.options.childSorter || defaultGearSort);
    }
    visit(visitor) {
        if (visitor(this) !== false) {
            this.children.forEach(visitor);
        }
    }
}
